import { Icon } from "@assetwatch/ui";

type AssetBreadcrumbItem = {
  id: number | null;
  name: string;
};

type AssetBreadcrumbsProps = {
  path: AssetBreadcrumbItem[];
  onNavigate: (id: number | null) => void;
};

export function AssetBreadcrumbs({ path, onNavigate }: AssetBreadcrumbsProps) {
  return (
    <nav aria-label="Asset hierarchy" className="min-w-0 overflow-hidden">
      <ol className="flex min-w-0 items-center gap-(--spacing-4)">
        {path.map((asset, index) => {
          const isCurrent = index === path.length - 1;
          return (
            <li
              className="flex min-w-0 items-center gap-(--spacing-4)"
              key={asset.id ?? "root"}
            >
              {index > 0 ? (
                <Icon name="chevron-right" size="xs" tone="secondary" />
              ) : null}
              {isCurrent ? (
                <span className="min-w-0 truncate font-(family-name:--font-family-body) text-(length:--font-size-body-medium) font-(number:--font-weight-semibold) text-text-default">
                  {asset.name}
                </span>
              ) : (
                <button
                  className="min-w-0 truncate rounded-(--radius-xs) px-(--spacing-4) font-(family-name:--font-family-body) text-(length:--font-size-body-medium) text-text-default outline-none hover:bg-surface-hover focus-visible:ring-2 focus-visible:ring-button-focus-ring"
                  onClick={() => onNavigate(asset.id)}
                  type="button"
                >
                  {asset.name}
                </button>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
